import { get, put, del, fetchWithAuth } from '../utils/httpInterceptor';
import { getCompanyId } from '../utils/companyHelper';
import { buildCrudQueryParams } from './filterQueryBuilder';

class ProductService {

    static async getAll(page, size, filters = {}, sortConfig = {}) {
        const companyId = getCompanyId();
        const queryParams = buildCrudQueryParams({
            page,
            size,
            filters,
            sortConfig,
            companyId,
            sortMode: 'split',
        });
        return await get(`/product?${queryParams.toString()}`);
    }

    static async createProduct(newProduct) {
        const companyId = getCompanyId();
        // FormData necesita tratamiento especial
        let productData = newProduct;
        if (productData instanceof FormData) {
            if (companyId) {
                productData.append('companyId', companyId);
            }
        } else {
            productData = {
                ...productData,
                companyId: companyId
            };
        }
        
        const response = await fetchWithAuth('/product', {
            method: 'POST',
            body: productData,
        });
        return await response.json();
    }

    static async updateProduct(productId, updatedProduct) {
        const companyId = getCompanyId();
        // FormData necesita tratamiento especial
        let productData = updatedProduct;
        if (productData instanceof FormData) {
            if (companyId) {
                productData.append('companyId', companyId);
            }
        } else {
            productData = {
                ...productData,
                companyId: companyId
            };
        }
        
        return await fetchWithAuth(`/product/${productId}`, {
            method: 'PUT',
            body: productData,
        });
    }

    static async deleteProduct(productId) {
        return await del(`/product/${productId}`);
    }

    static async updateEnabled(productId, updatedProduct) {
        const companyId = getCompanyId();
        const productData = {
            ...updatedProduct,
            companyId: companyId
        };
        return await put(`/product/enabled/${productId}`, productData);
    }

    // Alias para compatibilidad con CrudManager
    static async create(newProduct) {
        return this.createProduct(newProduct);
    }

    static async update(productId, updatedProduct) {
        return this.updateProduct(productId, updatedProduct);
    }

    static async delete(productId) {
        return this.deleteProduct(productId);
    }
}

export default ProductService;
